<template>
  <v-card max-width="500px" min-width="300px" class="pa-2">
    <v-card-actions v-if="!!isShowBtnSubmit" class="pb-2">
      <v-tooltip v-if="!!tooltipMsg" bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" style="width:100%">
            <v-btn
              block
              color="success darken-2"
              type="submit"
              :disabled="isLoading || isSubmitDisabled"
              :isLoading="isLoading"
              v-bind="attrs"
              @click="submit"
            >
              {{ isNew ? 'создать' : 'сохранить' }}
            </v-btn>
          </div>
        </template>
        <span>{{ tooltipMsg }}</span>
      </v-tooltip>
      <v-btn
        v-else
        block
        color="success darken-2"
        type="submit"
        :disabled="isLoading || isSubmitDisabled"
        :isLoading="isLoading"
        @click="submit"
      >
        {{ isNew ? 'создать' : 'сохранить' }}
      </v-btn>

    </v-card-actions>
    <v-divider />
    <v-card-text
      style="overflow-y: auto; max-height: 70vh"
      class="_app-scrollbar pa-0"
    >
      <v-card flat>
        <v-card-subtitle class="grey--text" v-if="createdAt || updatedAt || publishedAt">
          Основная информация
        </v-card-subtitle>
        <v-card-text>
          <slot name="info-prepend" />
          <v-row v-if="createdAt">
            <v-col cols="6"> Создано: </v-col>
            <v-col cols="6">
              {{ moment(createdAt).format($options.defaultDateTimeFormat) }}
            </v-col>
          </v-row>
          <v-row v-if="updatedAt">
            <v-col cols="6"> Обновлено: </v-col>
            <v-col cols="6">
              {{ moment(updatedAt).format($options.defaultDateTimeFormat) }}
            </v-col>
          </v-row>
          <v-row v-if="entityId && entityType" align="center">
            <v-col cols="6"> Действия </v-col>
            <v-col cols="6">
              <router-link
                :to="{
                  name: 'page-actions-dictionary',
                  query: {
                    t_id: +entityId,
                    t_scope: entityType
                  }
                }"
              >
                <v-btn icon>
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </router-link>
            </v-col>
          </v-row>
          <v-row v-if="publishedAt">
            <v-col cols="6"> Опубликовано: </v-col>
            <v-col cols="6">
              {{ moment(publishedAt).format($options.defaultDateTimeFormat) }}
            </v-col>
          </v-row>
          <v-row v-if="author">
            <v-col cols="6"> Автор: </v-col>
            <v-col cols="6">
              {{ author }}
            </v-col>
          </v-row>
          <slot name="info-append" />
        </v-card-text>
      </v-card>
      <template v-if="isLocales">
        <v-divider />
        <v-card flat>
          <v-card-subtitle class="grey--text"> Локализация </v-card-subtitle>
          <v-card-text>
            <v-row no-gutters>
              <v-select
                outlined
                item-value="value"
                item-text="title"
                hide-details
                dense
                :items="$options.contentLocales"
                :disabled="isNew || isLoading"
                :loading="isLoading"
                :value="language"
                @change="updateLocaleHandler"
              />
            </v-row>
            <v-row align="center" v-if="false">
              <v-col cols="6"> Доступно на портале </v-col>
              <v-col cols="6">
                <v-switch
                  v-if="translations"
                  inset
                  dense
                  :disabled="isLoading"
                  :loading="isLoading"
                  :input-value="getTranslationStatus()"
                  @change="
                    $emit('update-translations', { [language]: { isEnabled: $event } })
                  "
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-divider />
      </template>
      <template v-if="isShowSortOrder">
        <v-divider />
        <v-card flat>
          <v-card-subtitle class="grey--text"> Сортировка </v-card-subtitle>
          <v-card-text>
            <v-row no-gutters>
              <v-text-field
                outlined
                dense
                :loading="isLoading"
                :disabled="isLoading"
                :value="sortOrder"
                @change="$emit('update-sort-order', $event)"
              />
            </v-row>
            <v-row align="center" v-if="false">
              <v-col cols="6"> Доступно на портале </v-col>
              <v-col cols="6">
                <v-switch
                  v-if="translations"
                  inset
                  dense
                  :disabled="isLoading"
                  :loading="isLoading"
                  :input-value="getTranslationStatus()"
                  @change="
                    $emit('update-translations', { [language]: { isEnabled: $event } })
                  "
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-divider />
      </template>
      <slot name="body" />
      <v-divider class="my-5" />
    </v-card-text>
    <v-card-actions class="mt-auto">
      <v-btn
        width="100%"
        type="button"
        text
        color="grey darken-1"
        :disabled="isLoading"
        @click="$emit('cancel')"
      >
        отмена
      </v-btn>
    </v-card-actions>
    <v-card-actions class="mt-auto">
      <v-btn
        v-if="!isNew"
        block
        text
        color="error darken-2"
        :disabled="isLoading || isProtected"
        :isLoading="isLoading"
        @click="$emit('delete')"
      >
        удалить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import { defaultDateTimeFormat } from '@/configs/date.js'
import { contentLocales } from '@/configs/locales.js'
export default {
  name: 'ManageSidePanel',
  defaultDateTimeFormat,
  contentLocales,
  props: {
    isNew: {
      type: Boolean,
      default: true
    },
    createdAt: {
      type: String,
      default: null
    },
    entityId: {
      type: Number,
      default: null
    },
    entityType: {
      type: String,
      default: null
    },
    updatedAt: {
      type: String,
      default: null
    },
    publishedAt: {
      type: String,
      default: null
    },
    author: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isProtected: {
      type: Boolean,
      default: false
    },
    isSubmitDisabled: {
      type: Boolean,
      default: false
    },
    isLocales: {
      type: Boolean,
      default: true
    },
    language: {
      type: String,
      default: null
    },
    translations: {
      type: Object,
      default: () => ({})
    },
    isShowBtnSubmit: {
      type: Boolean,
      default: true
    },
    isShowSortOrder: {
      type: Boolean,
      default: false
    },
    sortOrder: {
      type: [String, Number],
      default: null
    },
    scrollXY: {
      default: null
    },
    tooltipMsg: {
      type: String,
      default: ''
    }
  },
  methods: {
    moment,
    getTranslationStatus () {
      if (!Object.keys(this.translations).length) return false
      if (!this.translations[this.language]) return false
      return this.translations[this.language].isEnabled
    },
    updateLocaleHandler (value) {
      this.$emit('language-update', value)
    },
    submit () {
      this.$emit('submit', {
        data: {
          ...this.fields
        }
      })
    }
  }
}
</script>
